<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { authenticateMethods } from '@state/helpers'
import axios from 'axios'

export default {
	page: {
		title: '360MDR Start',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: {
		Layout
	},
	props: {
		code: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
            appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
            toLogin: false
		}
    },
	mounted () {
        let that = this
		const code = this.code

		if (code !== '') {
			this.login(code)
        }
        
        setTimeout(function(){ 
			const idToken = localStorage.getItem('idToken')
			const expiresTS = localStorage.getItem('expiresTS')
            if (idToken !== null && idToken !== undefined) {
                axios.defaults.headers.common['Authorization'] = idToken
                that.$router.push({ name: 'Home' })
			} else if (expiresTS !== null && expiresTS !== undefined) {
				if (Date.now() > parseInt(expiresTS)) {
					that.toLogin = true
					// Luego hacer refrescar
				}
			}
			else {
                that.toLogin = true
            }
        }, 2500);
	},
	methods: {
		...authenticateMethods,
		AWSOauth2Token() {
			let that = this
			let baseURL = appConfig.AWS.oauth2TokenURL || ""

			const params = new URLSearchParams()
			params.append('grant_type', 'authorization_code')
			params.append('client_id', appConfig.AWS.appClientID)
			params.append('redirect_uri', appConfig.AWS.redirectURI)
			params.append('code', that.code);

			let headers = {
				"Content-Type": "application/x-www-form-urlencoded",
				"Authorization": appConfig.AWS.authorization
			}
			axios.post(baseURL, params, { headers: headers } ).then((response) => {
				if (response.status === 200) {
					that.$store.state.id_token = response.data.id_token
					that.$store.state.access_token = response.data.access_token
					that.$store.state.refresh_token = response.data.refresh_token
					that.$store.state.expires_in = response.data.expires_in
					that.$store.state.token_type = response.data.token_type
					that.$store.state.token_ts = parseInt(Date. now() / 1000)
				}
			})
		},
	},
	computed: {

	},
}
</script>

<template>
	<div>
		<div class="row page-title align-items-center">
			<div class="col-sm-12 col-xl-12">
				<h4 class="mb-1 mt-0"  style="text-align:center;">360MDR</h4>
			</div>
		</div>
        <div v-if="toLogin" class="row page-title align-items-center">
            <div class="col-sm-12 col-xl-12">
                <h4 class="mb-1 mt-0"  style="text-align:center;"><a :href="appConfig.AWS.cognitoLoginUI">Login</a></h4>
            </div>
        </div>
        <div v-else class="row page-title align-items-center">
            <div class="col-sm-12 col-xl-12">
                <h4 class="mb-1 mt-0"  style="text-align:center;">Starting...</h4>
            </div>
        </div>          
	</div>
</template>